// extracted by mini-css-extract-plugin
export var width100 = "K_w d_w";
export var design3Pos = "K_wj d_0";